export default function LoadingSpinner() {
  return (
    <div className="animate-spin h-8 w-8 border-4 border-pink-500 border-t-transparent rounded-full" />
  );
}